import { BaseService } from './baseService';
import axiosInstance from '../superadminAxiosInstance';

class AccountsService extends BaseService<Account, 'accountID', 'accounts'> {
	constructor() {
		super('accountID', 'account', 'accounts');
	}

	async deleteMultipleAccounts(
		data: DeleteMultipleAccountsRequest[],
	): Promise<void> {
		await axiosInstance.post(
			`/superAdmin/${this.crudResponseArrayName}/batch`,
			data,
		);
	}

	async addCredits(data: {
		accountID: number;
		creditCount: number;
	}): Promise<void> {
		await axiosInstance.post(
			`/superAdmin/${this.crudResponseArrayName}/${data.accountID}/addCredits`,
			{
				creditCount: data.creditCount,
			},
		);
	}

	async removeCredits(data: {
		accountID: number;
		creditCount: number;
	}): Promise<void> {
		await axiosInstance.post(
			`/superAdmin/${this.crudResponseArrayName}/${data.accountID}/removeCredits`,
			{
				creditCount: data.creditCount,
			},
		);
	}
}

// This type of exporting is intended to make sure service acts as a singleton.
export default new AccountsService();
